export type WeekTargetLevel = 'positive' | 'warning' | 'negative';

/** ≥ 90% green (on track), 75–90% orange (close), < 75% red (behind) — mirrored by the page legend. */
export function getWeekTargetLevel(percentage: number): WeekTargetLevel {
  if (percentage >= 90) return 'positive';
  if (percentage >= 75) return 'warning';
  return 'negative';
}

export const BAR_FILL_CLASS: Record<WeekTargetLevel, string> = {
  positive: 'bg-positive',
  warning: 'bg-warning',
  negative: 'bg-negative',
};
